import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "master-panel" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"left-panel\"><span class=\"helper\"></span><svg width=\"252\" height=\"100\" viewBox=\"0 0 252 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_2638_19881)\"><path d=\"M25.3734 74.7357C25.3734 80.947 20.3461 85.9743 14.1348 85.9743C7.9235 85.9743 2.89618 80.947 2.89618 74.7357C2.89618 68.5244 7.9235 63.4971 14.1348 63.4971C20.3461 63.4971 25.3734 68.5244 25.3734 74.7357Z\" fill=\"#5EBCB8\"></path><path d=\"M19.8543 58.6705V70.0366H12.4226V58.5612L0 37.9419H7.88707L16.4481 52.2042L25.0273 37.9419H32.3133L19.8543 58.6705Z\" fill=\"#0B3D52\"></path><path d=\"M44.7177 92.9874C44.7177 96.8671 41.5847 100 37.7049 100C33.8251 100 30.6922 96.8671 30.6922 92.9874C30.6922 89.1076 33.8251 85.9746 37.7049 85.9746C41.5847 85.9746 44.7177 89.1076 44.7177 92.9874Z\" fill=\"#5EBCB8\"></path><path d=\"M42.4955 64.4445H51.1658C55.0091 64.4445 57.0856 63.2605 57.0856 60.5101C57.0856 57.7596 55.0273 56.521 51.1658 56.521H42.4955V64.4445Z\" fill=\"#5EBCB8\"></path><path d=\"M55.4645 47.286C55.4645 44.7723 53.4973 43.5337 49.8725 43.5337H42.4955V51.0929H49.8725C53.4973 51.0929 55.4645 49.8178 55.4645 47.286Z\" fill=\"#5EBCB8\"></path><path d=\"M124.918 47.0308C124.918 44.4989 127.395 42.641 132.441 42.641C135.574 42.641 138.761 43.2967 141.658 45.1729L144.135 40.6009C141.366 38.7977 136.667 37.7048 132.514 37.7048C127.468 37.7048 123.588 39.1802 121.348 41.6392C120.619 18.5244 101.676 0.0180664 78.3971 0.0180664C56.357 0.0180664 38.2149 16.5937 35.7195 37.9598H50.7832C58.7978 37.9598 62.9326 41.3113 62.9326 46.3022C62.9326 49.508 61.275 51.9853 58.6703 53.3696C62.2404 54.5172 64.5355 57.2676 64.5355 61.2931C64.5355 66.8487 60.1275 70.0545 51.694 70.0545H44.9727C52.8597 79.7813 64.8816 86.0108 78.3789 86.0108C91.8761 86.0108 104.59 79.4352 112.459 69.2166V53.1146C112.459 47.9962 110.109 45.6465 106.047 45.6465C101.639 45.6465 98.4517 48.3605 98.4517 54.1711V69.8177H89.2714V38.1601H98.0328V41.876C100.51 39.162 104.208 37.7048 108.506 37.7048C113.515 37.7048 117.687 39.672 119.891 43.8614C119.435 44.8997 119.18 46.0472 119.18 47.2858C119.18 59.9998 139.362 53.7886 139.362 60.9652C139.362 63.6793 137.14 65.3004 131.767 65.3004C127.614 65.3004 123.279 63.9161 120.565 61.9853L118.16 66.5572C120.82 68.6702 126.047 70.2913 131.348 70.2913C139.836 70.2913 145.137 66.6119 145.137 60.8377C145.137 48.4334 124.9 54.5718 124.9 47.049M83.4062 69.7995H74.2259V38.1419H83.4062V69.7995ZM78.816 33.7339C75.4098 33.7339 73.1147 31.4935 73.1147 28.6155C73.1147 25.7376 75.4098 23.4971 78.816 23.4971C82.2222 23.4971 84.5173 25.61 84.5173 28.4334C84.5173 31.4935 82.2222 33.7339 78.816 33.7339Z\" fill=\"#5EBCB8\"></path><path d=\"M166.302 37.6867C161.603 37.6867 157.505 39.4899 154.918 43.0419V37.9781H149.381V81.5847H155.173V65.0819C157.814 68.5246 161.803 70.255 166.321 70.255C175.665 70.255 182.459 63.7522 182.459 53.9344C182.459 44.1165 175.647 37.6685 166.321 37.6685M165.829 65.2094C159.745 65.2094 155.1 60.7468 155.1 53.9526C155.1 47.1584 159.745 42.7504 165.829 42.7504C171.913 42.7504 176.612 47.2131 176.612 53.9526C176.612 60.6921 171.967 65.2094 165.829 65.2094Z\" fill=\"#5EBCB8\"></path><path d=\"M190.346 24.317C188.124 24.317 186.43 26.011 186.43 28.1057C186.43 30.2005 188.106 31.8398 190.346 31.8398C192.587 31.8398 194.262 30.1458 194.262 27.9782C194.262 25.9382 192.568 24.2988 190.346 24.2988\" fill=\"#5EBCB8\"></path><path d=\"M193.224 37.9966H187.45V69.9274H193.224V37.9966Z\" fill=\"#5EBCB8\"></path><path d=\"M206.794 43.3514V37.9962H201.257V69.927H207.031V54.0253C207.031 47.0308 210.893 43.2421 217.086 43.2421C217.505 43.2421 217.923 43.2421 218.415 43.2967V37.6865C212.805 37.6865 208.834 39.6173 206.794 43.3514Z\" fill=\"#5EBCB8\"></path><path d=\"M251.056 54.1346C251.056 44.3168 244.499 37.6865 235.282 37.6865C226.066 37.6865 219.253 44.4989 219.253 53.9525C219.253 63.406 226.12 70.273 236.412 70.273C241.712 70.273 246.12 68.4698 248.998 65.1L245.811 61.3659C243.461 63.9525 240.328 65.2275 236.594 65.2275C230.273 65.2275 225.756 61.4934 225.027 55.8832H250.929C250.984 55.3368 251.056 54.6082 251.056 54.1346ZM225.046 51.7302C225.647 46.3022 229.745 42.5681 235.282 42.5681C240.82 42.5681 244.918 46.3568 245.519 51.7302H225.046Z\" fill=\"#5EBCB8\"></path><path d=\"M64.5355 61.2752C64.5355 66.8126 60.1275 70.0366 51.694 70.0366H35.1002V37.9419H50.765C58.7796 37.9419 62.9144 41.2934 62.9144 46.2843C62.9144 49.4902 61.2568 51.9674 58.6521 53.3517C62.2222 54.4993 64.5173 57.2497 64.5173 61.2752M42.4955 43.5339V51.0931H49.8725C53.4973 51.0931 55.4645 49.818 55.4645 47.2862C55.4645 44.7543 53.4973 43.5339 49.8725 43.5339H42.4955ZM57.0674 60.492C57.0674 57.7962 55.0091 56.5029 51.1475 56.5029H42.4772V64.4264H51.1475C54.9909 64.4264 57.0674 63.2424 57.0674 60.492Z\" fill=\"#0B3D52\"></path></g><defs><clipPath id=\"clip0_2638_19881\"><rect width=\"251.056\" height=\"100\" fill=\"white\"></rect></clipPath></defs></svg></div>", 1)
const _hoisted_3 = { class: "right-panel" }
const _hoisted_4 = {
  key: 0,
  class: "m-0"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "register-fields-block" }
const _hoisted_8 = { class: "row-first-name" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "input-first-name-field" }
const _hoisted_11 = { class: "block-last-name" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "input-last-name-field" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "input-email-field" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "input-password" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { class: "input-confirm-password" }
const _hoisted_20 = {
  key: 0,
  class: "confirmation-message"
}
const _hoisted_21 = { class: "register-button-row" }
const _hoisted_22 = {
  key: 1,
  class: "m-0"
}
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = { class: "row-confirmation-code" }
const _hoisted_26 = {
  key: 0,
  class: "confirmation-message"
}
const _hoisted_27 = {
  key: 1,
  class: "confirmation-message"
}
const _hoisted_28 = {
  key: 2,
  class: "confirmation-message"
}
const _hoisted_29 = {
  key: 3,
  class: "confirmation-button-row"
}
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { class: "m-0" }
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = { class: "input-username" }
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = { class: "input-login-password" }
const _hoisted_37 = { class: "login-button-row" }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { class: "m-0" }
const _hoisted_40 = ["innerHTML"]
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = ["innerHTML"]
const _hoisted_43 = { class: "input-username" }
const _hoisted_44 = { class: "reset-password-button-row" }
const _hoisted_45 = { style: {"float":"left"} }
const _hoisted_46 = { style: {"float":"right"} }
const _hoisted_47 = { key: 2 }
const _hoisted_48 = { class: "m-0" }
const _hoisted_49 = ["innerHTML"]
const _hoisted_50 = ["innerHTML"]
const _hoisted_51 = { class: "input-login-password" }
const _hoisted_52 = ["innerHTML"]
const _hoisted_53 = { class: "input-login-password" }
const _hoisted_54 = { class: "login-button-row" }
const _hoisted_55 = { key: 3 }
const _hoisted_56 = { class: "m-0" }
const _hoisted_57 = ["innerHTML"]
const _hoisted_58 = { class: "row-confirmation-code" }
const _hoisted_59 = {
  key: 0,
  class: "confirmation-message"
}
const _hoisted_60 = {
  key: 1,
  class: "confirmation-message"
}
const _hoisted_61 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_62 = { class: "login-button-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Message = _resolveComponent("Message")!
  const _component_IciButton = _resolveComponent("IciButton")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabView = _resolveComponent("TabView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_TabView, {
        "active-index": _ctx.tabIndex,
        "onUpdate:activeIndex": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.tabIndex) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_TabPanel, {
            header: _ctx.$tc('register.title'),
            disabled: _ctx.disabledRegisterTab
          }, {
            default: _withCtx(() => [
              _createElementVNode("form", null, [
                (!_ctx.registerConfirmation)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                      _createElementVNode("div", {
                        class: "title",
                        innerHTML: _ctx.$tc('register.title')
                      }, null, 8, _hoisted_5),
                      _createElementVNode("div", {
                        class: "intro",
                        innerHTML: _ctx.$tc('register.intro')
                      }, null, 8, _hoisted_6),
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", {
                            class: "label-first-name-field",
                            innerHTML: _ctx.$tc('register.firstName')
                          }, null, 8, _hoisted_9),
                          _createElementVNode("div", _hoisted_10, [
                            _createVNode(_component_InputText, {
                              type: "text",
                              autocomplete: "off",
                              modelValue: _ctx.registerModel.firstName,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.registerModel.firstName) = $event)),
                              class: "field-first-name ps-1 py-1 ring-0 border-2 border-[#fff] focus:border-[#5ebcb8]"
                            }, null, 8, ["modelValue"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", {
                            class: "label-last-name-field",
                            innerHTML: _ctx.$tc('register.lastName')
                          }, null, 8, _hoisted_12),
                          _createElementVNode("div", _hoisted_13, [
                            _createVNode(_component_InputText, {
                              type: "text",
                              autocomplete: "off",
                              modelValue: _ctx.registerModel.lastName,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.registerModel.lastName) = $event)),
                              class: "field-last-name ps-1 py-1 ring-0 border-2 border-[#fff] focus:border-[#5ebcb8]"
                            }, null, 8, ["modelValue"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", {
                        class: "label-email-field",
                        innerHTML: _ctx.$tc('register.email')
                      }, null, 8, _hoisted_14),
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_InputText, {
                          type: "text",
                          autocomplete: "off",
                          modelValue: _ctx.registerModel.email,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.registerModel.email) = $event)),
                          class: "field-email ps-1 py-1 ring-0 border-2 border-[#fff] focus:border-[#5ebcb8]"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", {
                        class: "label-password",
                        innerHTML: _ctx.$tc('register.password')
                      }, null, 8, _hoisted_16),
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_InputText, {
                          type: "password",
                          autocomplete: "new-password",
                          modelValue: _ctx.registerModel.password,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.registerModel.password) = $event)),
                          class: "field-password ps-1 py-1 ring-0 border-2 border-[#fff] focus:border-[#5ebcb8]"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", {
                        class: "label-confirm-password",
                        innerHTML: _ctx.$tc('register.confirmPassword')
                      }, null, 8, _hoisted_18),
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_InputText, {
                          type: "password",
                          autocomplete: "off",
                          modelValue: _ctx.registerModel.passwordConfirm,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.registerModel.passwordConfirm) = $event)),
                          class: "field-confirm-password ps-1 py-1 ring-0 border-2 border-[#fff] focus:border-[#5ebcb8]"
                        }, null, 8, ["modelValue"])
                      ]),
                      (_ctx.resultError)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            _createVNode(_component_Message, { severity: "error" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.errorMessage), 1)
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_IciButton, {
                          id: "register",
                          content: "Register",
                          onButtonClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.register())),
                          btnStyle: "padding: 16px 24px!important; width: auto;"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.registerConfirmation)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_22, [
                      _createElementVNode("div", {
                        class: "title",
                        innerHTML: _ctx.$tc('register.title')
                      }, null, 8, _hoisted_23),
                      _createElementVNode("div", {
                        class: "intro",
                        innerHTML: 'To complete your registration, we have,<br/>sent you a confirmation code via email.</br></br>Please enter the six digit code, which you have<br/>received in your email, and click confirm.'
                      }, null, 8, _hoisted_24),
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_InputText, {
                          type: "text",
                          maxlength: "1",
                          modelValue: _ctx.confirmDigit1,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.confirmDigit1) = $event)),
                          autocomplete: "off",
                          class: "field-confirmation-code ps-1 py-1 ring-0 border-2 border-[#fff] focus:border-[#5ebcb8]"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_InputText, {
                          type: "text",
                          maxlength: "1",
                          modelValue: _ctx.confirmDigit2,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.confirmDigit2) = $event)),
                          autocomplete: "off",
                          class: "field-confirmation-code ps-1 py-1 ring-0 border-2 border-[#fff] focus:border-[#5ebcb8]"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_InputText, {
                          type: "text",
                          maxlength: "1",
                          modelValue: _ctx.confirmDigit3,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.confirmDigit3) = $event)),
                          autocomplete: "off",
                          class: "field-confirmation-code ps-1 py-1 ring-0 border-2 border-[#fff] focus:border-[#5ebcb8]"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_InputText, {
                          type: "text",
                          maxlength: "1",
                          modelValue: _ctx.confirmDigit4,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.confirmDigit4) = $event)),
                          autocomplete: "off",
                          class: "field-confirmation-code ps-1 py-1 ring-0 border-2 border-[#fff] focus:border-[#5ebcb8]"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_InputText, {
                          type: "text",
                          maxlength: "1",
                          modelValue: _ctx.confirmDigit5,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.confirmDigit5) = $event)),
                          autocomplete: "off",
                          class: "field-confirmation-code ps-1 py-1 ring-0 border-2 border-[#fff] focus:border-[#5ebcb8]"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_InputText, {
                          type: "text",
                          maxlength: "1",
                          modelValue: _ctx.confirmDigit6,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.confirmDigit6) = $event)),
                          autocomplete: "off",
                          class: "field-confirmation-code ps-1 py-1 ring-0 border-2 border-[#fff] focus:border-[#5ebcb8]"
                        }, null, 8, ["modelValue"])
                      ]),
                      (_ctx.confirmationInCorrect)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _createVNode(_component_Message, { severity: "error" }, {
                              default: _withCtx(() => [
                                _createTextVNode("The code is not correct. Please correct the numbers according to the code in the email, and press confirm again")
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.confirmationExpired)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            _createVNode(_component_Message, { severity: "error" }, {
                              default: _withCtx(() => [
                                _createTextVNode("The code is expired.Please click the resend code button, to receive another email with a new code.")
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.confirmationFinished)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _createVNode(_component_Message, { severity: "success" }, {
                              default: _withCtx(() => [
                                _createTextVNode("The code is successfully validated. You are now able to login.")
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.confirmationFinished)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            (!_ctx.confirmationExpired)
                              ? (_openBlock(), _createBlock(_component_IciButton, {
                                  key: 0,
                                  id: "confirm",
                                  content: "Confirm",
                                  onButtonClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.confirm())),
                                  btnStyle: "width: 110px;"
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.confirmationExpired)
                              ? (_openBlock(), _createBlock(_component_IciButton, {
                                  key: 1,
                                  id: "confirm",
                                  content: "Resend Code",
                                  onButtonClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.resend())),
                                  btnStyle: "width: 140px;"
                                }))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["header", "disabled"]),
          _createVNode(_component_TabPanel, {
            header: _ctx.$tc('login.title')
          }, {
            default: _withCtx(() => [
              (!_ctx.forgotPasswordMode && !_ctx.chooseNewPasswordMode)
                ? (_openBlock(), _createElementBlock("form", _hoisted_30, [
                    _createElementVNode("p", _hoisted_31, [
                      _createElementVNode("div", {
                        class: "title",
                        innerHTML: _ctx.$tc('login.title')
                      }, null, 8, _hoisted_32),
                      _createElementVNode("div", {
                        class: "label-username",
                        innerHTML: _ctx.$tc('login.email')
                      }, null, 8, _hoisted_33),
                      _createElementVNode("div", _hoisted_34, [
                        _createVNode(_component_InputText, {
                          type: "text",
                          autocomplete: "off",
                          modelValue: _ctx.loginModel.email,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.loginModel.email) = $event)),
                          class: "field-username ps-1 py-1 ring-0 border-2 border-[#fff] focus:border-[#5ebcb8]"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", {
                        class: "label-login-password",
                        innerHTML: _ctx.$tc('login.password')
                      }, null, 8, _hoisted_35),
                      _createElementVNode("div", _hoisted_36, [
                        _createVNode(_component_InputText, {
                          type: "password",
                          autocomplete: "current-password",
                          modelValue: _ctx.loginModel.password,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.loginModel.password) = $event)),
                          class: "field-login-password ps-1 py-1 ring-0 border-2 border-[#fff] focus:border-[#5ebcb8]"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", {
                          class: "forgot-password-link",
                          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.forgotPassword()))
                        }, "Forgot Password?"),
                        _createVNode(_component_IciButton, {
                          id: "login",
                          content: "Login",
                          onButtonClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.login())),
                          btnStyle: "padding:  16px 24px!important; width: auto;"
                        })
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.forgotPasswordMode && !_ctx.chooseNewPasswordMode && !_ctx.confirmNewPasswordMode)
                ? (_openBlock(), _createElementBlock("form", _hoisted_38, [
                    _createElementVNode("p", _hoisted_39, [
                      _createElementVNode("div", {
                        class: "title",
                        innerHTML: _ctx.$tc('login.forgotPasswordTitle')
                      }, null, 8, _hoisted_40),
                      _createElementVNode("div", {
                        style: {"margin-top":"30px"},
                        innerHTML: _ctx.$tc('login.forgotPasswordDetails')
                      }, null, 8, _hoisted_41),
                      _createElementVNode("div", {
                        class: "label-username",
                        innerHTML: _ctx.$tc('login.email')
                      }, null, 8, _hoisted_42),
                      _createElementVNode("div", _hoisted_43, [
                        _createVNode(_component_InputText, {
                          type: "text",
                          autocomplete: "off",
                          modelValue: _ctx.loginModel.email,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.loginModel.email) = $event)),
                          class: "field-username ps-1 py-1 ring-0 border-2 border-[#fff] focus:border-[#5ebcb8]"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("div", _hoisted_45, [
                          _createVNode(_component_IciButton, {
                            id: "login",
                            content: "Cancel",
                            onButtonClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.cancelResetPassword())),
                            btnStyle: "padding:  16px 24px!important; width: auto;"
                          })
                        ]),
                        _createElementVNode("div", _hoisted_46, [
                          _createVNode(_component_IciButton, {
                            id: "login",
                            content: "Reset Password",
                            onButtonClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.resetPassword())),
                            btnStyle: "padding:  16px 24px!important; width: auto;"
                          })
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.forgotPasswordMode && _ctx.chooseNewPasswordMode)
                ? (_openBlock(), _createElementBlock("form", _hoisted_47, [
                    _createElementVNode("p", _hoisted_48, [
                      _createElementVNode("div", {
                        class: "title",
                        innerHTML: _ctx.$tc('login.title')
                      }, null, 8, _hoisted_49),
                      _createElementVNode("div", {
                        class: "label-login-password",
                        innerHTML: _ctx.$tc('login.password')
                      }, null, 8, _hoisted_50),
                      _createElementVNode("div", _hoisted_51, [
                        _createVNode(_component_InputText, {
                          type: "password",
                          autocomplete: "current-password",
                          modelValue: _ctx.registerModel.password,
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.registerModel.password) = $event)),
                          class: "field-login-password ps-1 py-1 ring-0 border-2 border-[#fff] focus:border-[#5ebcb8]"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", {
                        class: "label-login-password",
                        innerHTML: _ctx.$tc('register.confirmPassword')
                      }, null, 8, _hoisted_52),
                      _createElementVNode("div", _hoisted_53, [
                        _createVNode(_component_InputText, {
                          type: "password",
                          autocomplete: "current-password",
                          modelValue: _ctx.registerModel.passwordConfirm,
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.registerModel.passwordConfirm) = $event)),
                          class: "field-login-password ps-1 py-1 ring-0 border-2 border-[#fff] focus:border-[#5ebcb8]"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_54, [
                        _createVNode(_component_IciButton, {
                          id: "login",
                          content: "Set Password",
                          onButtonClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.setPassword())),
                          btnStyle: "padding:  16px 24px!important; width: auto;"
                        })
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.forgotPasswordMode && _ctx.confirmNewPasswordMode)
                ? (_openBlock(), _createElementBlock("form", _hoisted_55, [
                    _createElementVNode("p", _hoisted_56, [
                      _createElementVNode("div", {
                        class: "title",
                        innerHTML: _ctx.$tc('login.title')
                      }, null, 8, _hoisted_57),
                      _createElementVNode("div", _hoisted_58, [
                        _createVNode(_component_InputText, {
                          type: "text",
                          maxlength: "1",
                          modelValue: _ctx.confirmDigit1,
                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.confirmDigit1) = $event)),
                          autocomplete: "off",
                          class: "field-confirmation-code ps-1 py-1 ring-0 border-2 border-[#fff] focus:border-[#5ebcb8]"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_InputText, {
                          type: "text",
                          maxlength: "1",
                          modelValue: _ctx.confirmDigit2,
                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.confirmDigit2) = $event)),
                          autocomplete: "off",
                          class: "field-confirmation-code ps-1 py-1 ring-0 border-2 border-[#fff] focus:border-[#5ebcb8]"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_InputText, {
                          type: "text",
                          maxlength: "1",
                          modelValue: _ctx.confirmDigit3,
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.confirmDigit3) = $event)),
                          autocomplete: "off",
                          class: "field-confirmation-code ps-1 py-1 ring-0 border-2 border-[#fff] focus:border-[#5ebcb8]"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_InputText, {
                          type: "text",
                          maxlength: "1",
                          modelValue: _ctx.confirmDigit4,
                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.confirmDigit4) = $event)),
                          autocomplete: "off",
                          class: "field-confirmation-code ps-1 py-1 ring-0 border-2 border-[#fff] focus:border-[#5ebcb8]"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_InputText, {
                          type: "text",
                          maxlength: "1",
                          modelValue: _ctx.confirmDigit5,
                          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.confirmDigit5) = $event)),
                          autocomplete: "off",
                          class: "field-confirmation-code ps-1 py-1 ring-0 border-2 border-[#fff] focus:border-[#5ebcb8]"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_InputText, {
                          type: "text",
                          maxlength: "1",
                          modelValue: _ctx.confirmDigit6,
                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.confirmDigit6) = $event)),
                          autocomplete: "off",
                          class: "field-confirmation-code ps-1 py-1 ring-0 border-2 border-[#fff] focus:border-[#5ebcb8]"
                        }, null, 8, ["modelValue"])
                      ]),
                      (_ctx.passwordResetConfirmationCodeInValid)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                            _createVNode(_component_Message, { severity: "error" }, {
                              default: _withCtx(() => [
                                _createTextVNode("The code is invalid. Please check the code in the email.")
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.passwordResetSuccessful)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                            _createVNode(_component_Message, { severity: "success" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Your password is successful changed."),
                                _hoisted_61,
                                _createTextVNode("You can now login using your new password.")
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_62, [
                        _createVNode(_component_IciButton, {
                          id: "login",
                          content: "Confirm New Password",
                          onButtonClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.confirmNewPassword())),
                          btnStyle: "padding:  16px 24px!important; width: auto;"
                        })
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["header"])
        ]),
        _: 1
      }, 8, ["active-index"])
    ])
  ]))
}